import { IBrand } from "@faire/web-api--source/indigofair/data/IBrand";

export const isBrandInNAM = (brand: IBrand | undefined) => {
  return brand?.based_in === "USA" || brand?.based_in === "CAN";
};
